<template>
  <div class="container min-body-height" :class="UI.isMobile ? '' : 'padding-top'">
    <div
      class="flex align-center justify-between"
      :class="UI.isMobile ? 'flex-direction' : ''"
    >
      <h1>正在报名运动员列表</h1>
      <el-form
        :inline="!UI.isMobile"
        :label-position="UI.isMobile ? 'top' : 'right'"
        size="mini"
        :model="filterForm"
      >
        <el-form-item label="姓名">
          <el-input
            clearable
            v-model="filterForm.name"
            placeholder="请输入"
          ></el-input>
        </el-form-item>

        <el-form-item>
          <el-button
            type="primary"
            @click="
              page = 1;
              flushData();
            "
          >
            查询
          </el-button>
          <el-button
            @click="
              filterForm = { page: 1, page_size: 10 };
              flushData();
            "
          >
            重置
          </el-button>
        </el-form-item>
      </el-form>
    </div>

    <div class="full-width margin-bottom bg-grey" style="height: 1px;"></div>

    <el-table
      class="margin-top"
      :data="tableData"
      style="width: 100%"
      header-row-class-name="bg-default"
      :row-class-name="tableRowClassName"
      @cell-click="cellClick"
    >
      <el-table-column prop="name" label="姓名"></el-table-column>
      <el-table-column label="性别" v-if="!UI.isMobile">
        <template slot-scope="scope">
          {{ scope.row.sex == 0 ? '男' : '女' }}
        </template>
      </el-table-column>
      <el-table-column
        label="报名赛事"
        prop="game"
        v-if="!UI.isMobile"
      ></el-table-column>
      <el-table-column
        label="参赛项目"
        prop="item"
        v-if="!UI.isMobile"
      ></el-table-column>
      <el-table-column
        label="参赛组别"
        prop="group"
        v-if="!UI.isMobile"
      ></el-table-column>

      <el-table-column label="查看信息" v-else>
        <template slot-scope="scope">
          <el-button
            type="primary"
            size="small"
            @click="
              info = scope.row;
              isInfoShow = true;
            "
          >
            点击查看
          </el-button>
        </template>
      </el-table-column>
    </el-table>

    <el-dialog
      show-close
      :fullscreen="UI.isMobile"
      title="查看"
      :visible.sync="isInfoShow"
      width="98%"
      v-if="UI.isMobile"
    >
      <div class="padding-xs">
        <el-descriptions :column="1" border>
          <el-descriptions-item
            v-for="(value, key) in info"
            :key="key"
            :label="key"
          >
            <div v-if="!(value + '').startsWith('http')">{{ value }}</div>
            <div v-else>
              <el-button
                type="primary"
                size="small"
                @click="
                  fileUrl = value;
                  isShow = true;
                "
              >
                点击查看
              </el-button>
            </div>
          </el-descriptions-item>
        </el-descriptions>
      </div>
    </el-dialog>

    <el-dialog
      title="查看"
      :visible.sync="isShow"
      width="800px"
      show-close
      :fullscreen="UI.isMobile"
    >
      <pdf :src="fileUrl" v-if="fileUrl.endsWith('pdf')"></pdf>
      <img v-else :src="fileUrl" style="max-width: 500px;" />
    </el-dialog>
  </div>
</template>

<script>
import { getEnOwnerPlayers } from '@/servers/players.js';
import { showSuccessMsg } from '@/utils/uiUtils.js';
import { mapState } from 'vuex';
import pdf from '@/components/pdfShow.vue';

export default {
  components: {
    pdf,
  },

  data() {
    return {
      info: {},
      isInfoShow: false,
      isShow: false,
      fileUrl: '',
      filterForm: {
        page: 1,
        page_size: 10,
      },
      total: 0,
      tableData: [],
      approveBtn: ['warning', 'success', 'danger'],
    };
  },

  computed: {
    ...mapState(['UI']),
  },

  watch: {
    $route: 'routeChange',
  },

  mounted() {
    this.routeChange();
  },

  methods: {
    routeChange: function() {
      this.flushData();
    },

    flushData: function() {
      let that = this;
      getEnOwnerPlayers(function(res) {
        that.tableData = res;
      });
    },

    handleCurrentChange: function() {
      this.flushData();
    },

    tableRowClassName({ row, rowIndex }) {
      if (rowIndex % 2 == 0) {
        return 'bg-gray cursor-pointer';
      } else {
        return 'bg-white cursor-pointer';
      }
    },

    cellClick: function(row, column, cell, event) {
      this.$router.push({
        name: 'playerInfo',
        query: { id: row.id },
      });
      // const url = this.$router.resolve({
      //   name: 'playerInfo',
      //   query: { id: row.id },
      // });
      // window.open(url.href, '_blank');
    },
  },
};
</script>

<style></style>



// WEBPACK FOOTER //
// src/pages/index/players/org.vue